var vP7220 = require("./27.js");
function c(p7221, p7222 = 0) {
  if (typeof p7221 != "string" || p7222 === 0) {
    return p7221;
  } else if (p7221.length <= p7222) {
    return p7221;
  } else {
    return p7221.slice(0, p7222) + "...";
  }
}
exports.c = c;
function b(p7223, p7224) {
  let vP7223 = p7223;
  const v6082 = vP7223.length;
  if (v6082 <= 150) {
    return vP7223;
  }
  if (p7224 > v6082) {
    p7224 = v6082;
  }
  let v6083 = Math.max(p7224 - 60, 0);
  if (v6083 < 5) {
    v6083 = 0;
  }
  let v6084 = Math.min(v6083 + 140, v6082);
  if (v6084 > v6082 - 5) {
    v6084 = v6082;
  }
  if (v6084 === v6082) {
    v6083 = Math.max(v6084 - 140, 0);
  }
  vP7223 = vP7223.slice(v6083, v6084);
  if (v6083 > 0) {
    vP7223 = "'{snip} " + vP7223;
  }
  if (v6084 < v6082) {
    vP7223 += " {snip}";
  }
  return vP7223;
}
exports.b = b;
function a(p7225, p7226) {
  if (!Array.isArray(p7225)) {
    return "";
  }
  const vA318 = [];
  for (let vLN0965 = 0; vLN0965 < p7225.length; vLN0965++) {
    const v6085 = p7225[vLN0965];
    try {
      vA318.push(v6085 + "");
    } catch (e64) {
      vA318.push("[value cannot be serialized]");
    }
  }
  return vA318.join(p7226);
}
exports.a = a;
function f1112(p7227, p7228, p7229 = false) {
  return !!Object(vP7220.i)(p7227) && (Object(vP7220.h)(p7228) ? p7228.test(p7227) : !!Object(vP7220.i)(p7228) && (p7229 ? p7227 === p7228 : p7227.includes(p7228)));
}
function f1113(p7230, p7231 = [], p7232 = false) {
  return p7231.some(p7233 => f1112(p7230, p7233, p7232));
}
function f1114(p7234) {
  return p7234.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}